import { css } from '@emotion/react';

export default $ => css`
  .error-detail {
    margin-top: 8px;
  }

  .footer-errors-area {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .form-errors-trigger {
    position: relative;
    display: inline-flex;
    align-items: center;
  }

  .form-errors-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: transparent;
    border: none;
    color: ${$.dangerMain};
    font-size: 13px;
    font-weight: 600;
    padding: 4px 10px 4px 6px;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: ${$.dangerMain}18;
    }

    > .fa-exclamation-circle {
      font-size: 16px;
    }

    > .form-errors-caret {
      font-size: 11px;
      opacity: 0.7;
    }
  }

  .form-errors-dropdown {
    position: absolute;
    bottom: calc(100% + 10px);
    left: 0;
    min-width: 300px;
    max-width: 420px;
    background: ${$.white};
    border-radius: 10px;
    box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.12), 0 4px 24px rgba(0, 0, 0, 0.08);
    z-index: 200;
    overflow: hidden;

    .form-errors-dropdown-header {
      background-color: ${$.dangerMain};
      color: ${$.white};
      padding: 10px 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 600;
      font-size: 13px;
      gap: 8px;

      > span {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }

    .form-errors-close-btn {
      background: transparent;
      border: none;
      color: ${$.white};
      cursor: pointer;
      padding: 2px 6px;
      border-radius: 4px;
      opacity: 0.75;
      line-height: 1;
      transition: opacity 0.1s ease;

      &:hover {
        opacity: 1;
      }
    }

    .form-errors-list {
      list-style: none;
      padding: 6px 0;
      margin: 0;
      max-height: 280px;
      overflow-y: auto;

      .error-item {
        &:not(:last-child) {
          border-bottom: 1px solid ${$.inputBorderColor};
        }
      }

      .error-item-btn {
        width: 100%;
        background: transparent;
        border: none;
        text-align: left;
        padding: 9px 14px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        gap: 2px;
        transition: background-color 0.1s ease;

        &:hover {
          background-color: ${$.dangerMain}0f;
        }
      }

      .error-item-field {
        font-weight: 600;
        font-size: 12px;
        color: ${$.dangerMain};
        line-height: 1.3;
      }

      .error-item-msg {
        font-size: 12px;
        color: ${$.black};
        opacity: 0.75;
        line-height: 1.4;
        overflow-wrap: anywhere;
      }
    }
  }
`;
